export default "__VITE_ASSET__CYH1u7Ag__"